import useSWR from "swr";
import apiClient from "@/utils/apiClient";

export const useInitiativeSearch = (
  paramList,
  current = 1,
  pageSize = 24,
  order
) => {
  const sectionsList = paramList.sections ? paramList.sections : [];
  // const langList = paramList.langs ? paramList.langs : [];
  const yearList = paramList.years ? paramList.years : [];
  const countryList = paramList.countries ? paramList.countries : [];
  // Convert theme list in object format for qs search
  const getSectionsQuery = () => {
    let res = [];
    // if params are in an array, map to query structure
    if (Array.isArray(sectionsList)) {
      res = { secciones: { id: { $in: sectionsList } } };
    } else {
      // if there is only one string as the param query structure is a bit different.
      res = { secciones: { id: { $in: sectionsList } } };
    }
    return res;
  };
  // Convert langs list in object format for qs search
  const getLangsQuery = () => {
    let res = [];
    // if params are in an array, map to query structure
    if (Array.isArray(langList)) {
      res = { idiomas: { id: { $in: langList } } };
    } else {
      // if there is only one string as the param query structure is a bit different.
      res = { idiomas: { id: { $in: langList } } };
    }
    return res;
  };

  // Convert langs list in object format for qs search
  const getYearsQuery = () => {
    let res = [];
    // if params are in an array, map to query structure
    if (Array.isArray(yearList)) {
      res = { film_year: { year: { $in: yearList } } };
    } else {
      // if there is only one string as the param query structure is a bit different.
      res = { film_year: { year: { $in: yearList } } };
    }
    return res;
  };

  // Convert langs list in object format for qs search
  const getCountryQuery = () => {
    let res = [];
    // if params are in an array, map to query structure
    if (Array.isArray(countryList)) {
      res = { countries: { countries: { $in: countryList } } };
    } else {
      // if there is only one string as the param query structure is a bit different.
      res = { countries: { countries: { $in: countryList } } };
    }
    return res;
  };

  const qs = require("qs");
  const query = qs.stringify(
    {
      populate: ["film_cover_image", "Directores", "film_title"],
      locale: "es-MX",
      publicationState: "preview",
      filters: {
        $and: [
          { iniciativas: { slug: { $eq: paramList.slug } } },
          {
            $or: [
              getSectionsQuery(),
              // getLangsQuery(),
              getYearsQuery(),
              getCountryQuery(),
            ],
          },
        ],
      },
      sort: [order],
      pagination: {
        page: current,
        pageSize: pageSize,
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );
  const fetcher = (url) => apiClient.get(url).then((res) => res.data);
  const { data, error, mutate } = useSWR(`/api/films?${query}`, fetcher, {
    revalidateOnFocus: false,
  });
  return { data, isLoading: !error && !data, error, mutate };
};

export const useInitiatives = () => {
  const fetcher = (url) => apiClient.get(url).then((res) => res.data);
  const { data, error, mutate } = useSWR("/api/initiatives", fetcher);
  return { data, isLoading: !error && !data, error, mutate };
};
